<template>
  <div>
    <BaseModal :config="importModalConfig">
      <BaseAuditDropzone
        ref="programImportDropZone"
        :id="'drop'"
        :acceptedFileTypes="SheetJSFT"
        @change="_change"
        @Remove="_remove"
        :File="inputfile"
        :UploadType="FileUploadType"
        v-show="displayDropZone"
      ></BaseAuditDropzone>
    </BaseModal>
  </div>
</template>

<script>

import BaseModal from "@/components/base/BaseModal.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import { isNullOrUndefined } from "util";
import funcUtil from "@/services/funcUtil.js";
import moment from "moment";
import XLSX from "xlsx";
import sheetJSConfig from "@/configs/sheetJS.js";

export default {
  name: "ProgramImportDropZoneForm",
  props: {
    importModalConfig: {},
    displayDropZone:{type: Boolean,default: true},
    ProgramInfoTemplate : {}
  },
  mixins: [funcUtil],
  components: {
    BaseModal,
    BaseAuditDropzone
  },
  data: function() {
    return {
      inputfile: {
        UploadFile: {}
      },
      FileUploadType: {
        AllowMultiple: false
      },
      InvestmentID:-1,
      SheetJSFT: sheetJSConfig.fileType,
    };
  },
  methods: {
    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files);
    },
    _remove(evt) {
      //Remove Code
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        const self=this;
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) 
          {
              binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary;
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Program  data */
          const Progws = wb.Sheets["Program"];
          const Programdata = XLSX.utils.sheet_to_json(Progws, {
						range: sheetJSConfig.template.header - 1, 
            header: 1
          });
          //console.log(Programdata);
          if (Programdata && Programdata.length>1) {

            this.ProgramInfoTemplate.parent.Title = !isNullOrUndefined(
              Programdata[1][0]
            )
              ? Programdata[1][0]
              : null;
            this.ProgramInfoTemplate.parent.Alias = !isNullOrUndefined(
              Programdata[1][1]
            )
              ? Programdata[1][1]
              : null;
            
            this.ProgramInfoTemplate.parent.InvestmentId = [];            
                     
            this.ProgramInfoTemplate.parent.EIN = !isNullOrUndefined(
              Programdata[1][2]
            )
              ? Programdata[1][2]
              : null;
            this.ProgramInfoTemplate.parent.FormationDate = self._getExcelPlatformCode(Programdata[1][3]);
            // !isNullOrUndefined(
            //   Programdata[1][3]
            // )
            //   ? moment(
            //       new Date(
            //         Math.round((Programdata[1][3] - 25569) * 86400 * 1000)
            //       )
            //     ).format("MM/DD/YYYY")
            //   : null;

            this.ProgramInfoTemplate.parent.IncomeSource = !isNullOrUndefined(
              Programdata[1][4]
            )
              ? Programdata[1][4].split(",")
              : null;

            this.ProgramInfoTemplate.parent.StateSource = !isNullOrUndefined(
              Programdata[1][5]
            )
              ? Programdata[1][5].split(",")
              : null;

            this.ProgramInfoTemplate.parent.Note = !isNullOrUndefined(
              Programdata[1][6]
            )
              ? Programdata[1][6]
              : null;
          }

          /* Get Vesting  data */
          const Vestingws = wb.Sheets["Vesting"];
          const Vestingdata = XLSX.utils.sheet_to_json(Vestingws, {
						range: sheetJSConfig.template.header - 1, 
            header: 1
          });
          //console.log(Vestingdata);
          if (Vestingdata && Vestingdata.length) {
            Vestingdata.splice(0, 1);
            let vestingArr = [];
            let count = 1;
            for (var i = 0; i < Vestingdata.length; i++) {
              var vestObj = {};
              //console.log(classdata[i])
              vestObj.UnitClass = !isNullOrUndefined(Vestingdata[i][0])
                ? Vestingdata[i][0]
                : null;
              vestObj.UnitType = !isNullOrUndefined(Vestingdata[i][1])
                ? Vestingdata[i][1]
                : null; 
              vestObj.VestingType = !isNullOrUndefined(Vestingdata[i][2])
                ? Vestingdata[i][2]
                : null;
              vestObj.Year = !isNullOrUndefined(Vestingdata[i][3])
                ? Vestingdata[i][3]
                : null;
              vestObj.VestDate = self._getExcelPlatformCode(Vestingdata[i][4]);
              // !isNullOrUndefined(Vestingdata[i][4])
              //   ? moment(
              //       new Date(
              //         Math.round((Vestingdata[i][4] - 25569) * 86400 * 1000)
              //       )
              //     ).format("MM/DD/YYYY")
              //   : null;
              vestObj.Percentage = !isNullOrUndefined(Vestingdata[i][5])
                ? Vestingdata[i][5]
                : null;
              vestObj.Note = !isNullOrUndefined(Vestingdata[i][6])
                ? Vestingdata[i][6]
                : null;
              vestObj.vestingKey = count++;
              vestingArr.push(vestObj);
            }

            this.ProgramInfoTemplate.children.VestingSchedule = vestingArr;
          }

          /* Get class  data */
          const Classws = wb.Sheets["Class"];
          const Classdata = XLSX.utils.sheet_to_json(Classws, {
						range: sheetJSConfig.template.header - 1, 
            header: 1
          });
          console.log(Classdata);
          if (Classdata && Classdata.length) {
            this.displayPage = true;

            Classdata.splice(0, 1);

            let classArr = [];
            let count = 1;
            for (var i = 0; i < Classdata.length; i++) {
              var classObj = {};
              //console.log(classdata[i])
              classObj.UnitClass = !isNullOrUndefined(Classdata[i][0])
                ? Classdata[i][0]
                : null;
              classObj.PartnerType = !isNullOrUndefined(Classdata[i][1])
                ? Classdata[i][1]
                : null;
              classObj.Ownership = !isNullOrUndefined(Classdata[i][2])
                ? Classdata[i][2]
                : null;
              classObj.UnitPrice = !isNullOrUndefined(Classdata[i][3])
                ? Classdata[i][3]
                : null;
              classObj.InitialAwardDate = self._getExcelPlatformCode(Classdata[i][4]);
              // !isNullOrUndefined(Classdata[i][4])
              //   ? moment(
              //       new Date(
              //         Math.round((Classdata[i][4] - 25569) * 86400 * 1000)
              //       )
              //     ).format("MM/DD/YYYY")
              //   : null;
              classObj.SubjectToVesting = !isNullOrUndefined(Classdata[i][5])
                ? Classdata[i][5]
                : null;
              classObj.Note = !isNullOrUndefined(Classdata[i][6])? Classdata[i][6]: "";
              classObj.classKey = count++;
              classArr.push(classObj);
 
            }
            this.ProgramInfoTemplate.children.UnitClass = classArr;
          }
        };
         reader.readAsArrayBuffer(file);
        //Raise Event That Read Has Been Completed
        this.$emit("readComplete",file);
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  mounted() {}
};
</script>
